import { Tuple } from '../../../types';
import { textMandatory, maxLength } from '../../validationFunctions';
import * as validatorRules from '../../validatorRules.json';
import { interpolateValidationRule } from '../../validatorMessages';
import { SupportingActivityItemModel } from '../../../api/models';

const entityNameValidator = (values: Partial<SupportingActivityItemModel>): Tuple<(value: any) => boolean, string>[] => {
    return [
        [textMandatory, validatorRules.BR1_Mandatory_Field.FieldMessage],
        [maxLength(250), interpolateValidationRule(validatorRules.BR3_Maximum_Field_Length, [], ['250'])],
    ];
};

export default entityNameValidator;
